import React, { useEffect, useState, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { BASE_URL } from "../properties";
import { toogleLoad } from "../redux/slices/appslice";
import MovimientosCmpt from "../components/movimientosCmpt";

function MovimientosWebView() {
    const { tipo } = useParams();
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [titulo, setTitulo] = useState("");
    const isFetching = useRef(false);

    const fetchMovimientosWebView = useCallback(async (filtroTitulo) => {
        // Validación crítica
        if (isFetching.current) return;
        if (!window.AppInventoryCredentials || !window.AppInventoryCredentials.idToken) {
            console.log("⚠️ Intento de fetch fallido: Faltan credenciales en window.AppInventoryCredentials");
            return;
        }

        isFetching.current = true;
        console.log("🚀 Iniciando Fetch a la API con:", window.AppInventoryCredentials);
        dispatch(toogleLoad(true));

        try {
            const webViewData = window.AppInventoryCredentials;
            const bodyPayload = {
                "DatosEncriptados": webViewData.DatosEncriptados
            };

            console.log(bodyPayload);

            const response = await fetch(`${BASE_URL}/saldos/movimientos`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': webViewData.idToken 
                },
                body: JSON.stringify({ DatosEncriptados: bodyPayload.DatosEncriptados })
            });

            const result = await response.json();
            console.log("✅ Respuesta del servidor recibida:", result);

            if (result.BanderaExito && result.Datos) {
                const item = result.Datos.find(d =>
                    d.Producto[0].TipoCliente.toUpperCase() === filtroTitulo.toUpperCase()
                );

                if (item) {
                    const combinados = [...item.MovimientoAhorro, ...item.MovimientoPrestamo];
                    combinados.sort((a, b) => b.Fecha.localeCompare(a.Fecha));
                    setData(combinados);
                } else {
                    console.warn("⚠️ No se encontró el producto:", filtroTitulo);
                }
            }
        } catch (error) {
            console.error("❌ Error en la petición API:", error);
        } finally {
            dispatch(toogleLoad(false));
            isFetching.current = false;
        }
    }, [dispatch]);

    useEffect(() => {
        const titulosMapa = {
            'fondodeahorro': 'Fondo de Ahorro',
            'cajadeahorro': 'Caja de Ahorro',
            'plandepensiones': 'Fondo de Pensiones'
        };

        const currentTitulo = titulosMapa[tipo];
        if (!currentTitulo) {
            console.error("❌ Tipo de fondo no válido en la URL:", tipo);
            return;
        }
        
        setTitulo(currentTitulo);
        console.log("🧐 Esperando credenciales para:", currentTitulo);

        // 1. Verificar si ya existen al cargar
        if (window.AppInventoryCredentials?.idToken) {
            console.log("✨ Credenciales detectadas al montar!");
            fetchMovimientosWebView(currentTitulo);
        }

        // 2. Intervalo de detección (Polling)
        const interval = setInterval(() => {
            if (window.AppInventoryCredentials?.idToken) {
                console.log("🎯 Polling detectó credenciales!");
                fetchMovimientosWebView(currentTitulo);
                clearInterval(interval);
            }
        }, 1000); // Revisar cada segundo

        return () => clearInterval(interval);
    }, [tipo, fetchMovimientosWebView]);

    return (
        <div className="webview-wrapper">
            <MovimientosCmpt 
                data={data} 
                titulo={titulo === 'Fondo de Pensiones' ? 'Plan de Pensiones' : titulo}
                isWebView={true} 
            />
        </div>
    );
}

export default MovimientosWebView;